import { axiosReq } from "utils";
import { ChallengeOverviewActions } from "./ChallengeOverviewReducer";

//get challenge types
export const getEquityData = (getToken, id, filter) => {
  return async (dispatch) => {
    try {
      const token = await getToken();

      dispatch(ChallengeOverviewActions.getEquityDataRequest());
      const response = await axiosReq({
        method: "get",
        url: `${process.env.REACT_APP_BACKEND_URL}/equity/historyByLogin/${id}`,
        withCredentials: true,
        params: { ...filter },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      dispatch(ChallengeOverviewActions.getEquityDataSuccess(response?.data));
    } catch (error) {
      dispatch(
        ChallengeOverviewActions.getEquityDataError(
          error.response?.data.message
        )
      );
    }
    dispatch(clearStates());
  };
};

//get challenge stageDetails
export const getStageDetails = (getToken, id, stage) => {
  return async (dispatch) => {
    try {
      const token = await getToken();

      dispatch(ChallengeOverviewActions.getChallengeStageInfoRequest());
      const response = await axiosReq({
        method: "get",
        url: `${process.env.REACT_APP_BACKEND_URL}/challenge/challengeStageDetails/${id}`,
        withCredentials: true,
        params: { challengeStageId: stage?.value },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      dispatch(
        ChallengeOverviewActions.getChallengeStageInfoSuccess(response?.data)
      );
    } catch (error) {
      dispatch(
        ChallengeOverviewActions.getChallengeStageInfoError(
          error.response?.data.message
        )
      );
    }
    dispatch(clearStates());
  };
};

//get stages by challenge
export const getStages = (getToken, id) => {
  return async (dispatch) => {
    try {
      const token = await getToken();

      dispatch(ChallengeOverviewActions.getStagesRequest());
      const response = await axiosReq({
        method: "get",
        url: `${process.env.REACT_APP_BACKEND_URL}/challengeStage/byChallenge/${id}`,
        withCredentials: true,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      dispatch(ChallengeOverviewActions.getStagesSuccess(response?.data));
    } catch (error) {
      dispatch(
        ChallengeOverviewActions.getStagesError(error.response?.data.message)
      );
    }
    dispatch(clearStates());
  };
};

//get challenge list

export const getChallenges = (getToken) => {
  return async (dispatch) => {
    try {
      const token = await getToken();
      dispatch(ChallengeOverviewActions.getChallengesRequest());
      const response = await axiosReq({
        method: "get",
        url: `${process.env.REACT_APP_BACKEND_URL}/challenge/getChallengesList`,
        withCredentials: true,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      dispatch(ChallengeOverviewActions.getChallengesSuccess(response?.data));
    } catch (error) {
      dispatch(
        ChallengeOverviewActions.getChallengesError(
          error.response?.data.message
        )
      );
    }
    dispatch(clearStates());
  };
};

//clear states
const clearStates = () => {
  return async (dispatch) => {
    setTimeout(() => {
      dispatch(ChallengeOverviewActions.clearStates());
    }, 3000);
  };
};
